import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface ApprovedOnPackageLanguageCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const ApprovedOnPackageLanguageCard: React.FC<ApprovedOnPackageLanguageCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'ApprovedOnPackageLanguage') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Approved On-Package Language for Product Claims"
      onEditClick={onEditClick}
    />
  );
};
